import { PrimitiveValueObject } from '@/domain/primitiveValueObject';

/**
 * 特定商取引法に基づく表記 商品代金以外に必要な料金（その他）
 */
export class SctActPriceOther extends PrimitiveValueObject<string> {
  /**
   * 生成
   * @param value 値
   * @returns 値
   */
  static create(value: string): SctActPriceOther {
    return new SctActPriceOther(value);
  }
}
